import dayjs, { ConfigType, Dayjs } from "dayjs";
import { DATE_FORMATS, type DateFormatName, type DateFormatPattern } from "./constants";

export type FormatDateOptions = {
  format?: DateFormatPattern;
  fallback?: string | null;
};

export const convertToDayjs = (input: ConfigType): Dayjs | null => {
  if (!input) return null;

  const date = dayjs(input);
  return date.isValid() ? date : null;
};

export const formatDate = (dateInput?: ConfigType, options?: FormatDateOptions): string | null => {
  const { format = DATE_FORMATS.display, fallback = "--" } = options || {};

  const date = convertToDayjs(dateInput);
  if (!date) return ([DATE_FORMATS.api, DATE_FORMATS.iso] as DateFormatPattern[]).includes(format) ? null : fallback;

  if (format === DATE_FORMATS.iso) return date.toISOString();

  return date.format(format);
};

export const formatDateByType = (date?: ConfigType, type: DateFormatName = "display") => {
  return formatDate(date, { format: DATE_FORMATS[type] });
};
